var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KnownContext, ResolveResponse, } from '@spotify-internal/remote-config-core';
import { Configuration, defineInternal, } from '@spotify-internal/remote-config-properties';
import { hashJsonValue } from '@spotify-internal/remote-config-common';
export const INFLIGHT_CONFIGURATIONS = new Map();
import { getLogger } from '@spotify-internal/remote-config-common';
export const contextHash = defineInternal({
    name: '#contextHash',
    description: 'Hash of the context when passing through initial-config-middleware',
    default: '',
});
const logger = getLogger('middleware:initial-configuration');
const CONTEXT_NOT_APPLICABLE_TO_ALL_ENVIRONMENTS = [
    'geoip_country',
    'user_country',
    'user_catalogue',
    'user_id',
    'username',
    'user_is_employee',
];
export function fromNextJsProps(json) {
    const configuration = Configuration.fromJSON(json);
    const configAssignmentId = configuration.getValue(ResolveResponse.configurationAssignmentId);
    if (!configAssignmentId) {
        return configuration;
    }
    if (INFLIGHT_CONFIGURATIONS.has(configAssignmentId)) {
        return INFLIGHT_CONFIGURATIONS.get(configAssignmentId);
    }
    return configuration;
}
export function toNextJsProps(config) {
    const json = config.toJSON();
    if (!INFLIGHT_CONFIGURATIONS.has(config.getValue(ResolveResponse.configurationAssignmentId))) {
        throw new Error('toNextJsProps can only be used with the initialConfigMiddleware.');
    }
    return json;
}
export const initialConfigMiddleware = next => (opt) => (ctx) => __awaiter(void 0, void 0, void 0, function* () {
    const hash = hashJsonValue(Object.assign(Object.assign({}, KnownContext.extract(excludeContext(ctx))), { auth: ctx.auth }));
    if (opt.initialConfiguration) {
        if (hash === opt.initialConfiguration.getValue(contextHash)) {
            return Configuration.builder(opt.initialConfiguration);
        }
    }
    const config = yield next(ctx);
    logger.info("Setting hash: '%s' on configuration", hash);
    config.setValue(contextHash, hash);
    if (ctx.req) {
        addToInflightConfigurations(config);
        ctx.req.on('close', () => {
            removeFromInflightConfigurations(config);
        });
    }
    return config;
});
function removeFromInflightConfigurations(config) {
    INFLIGHT_CONFIGURATIONS.delete(config.getValue(ResolveResponse.configurationAssignmentId));
}
function addToInflightConfigurations(config) {
    const configAssignmentId = config.getValue(ResolveResponse.configurationAssignmentId);
    if (configAssignmentId) {
        INFLIGHT_CONFIGURATIONS.set(configAssignmentId, config);
    }
}
function excludeContext(initialContext) {
    const newContext = Object.assign({}, initialContext);
    CONTEXT_NOT_APPLICABLE_TO_ALL_ENVIRONMENTS.forEach(k => {
        delete newContext[k];
    });
    return newContext;
}
//# sourceMappingURL=initial-config.js.map